import { toast } from 'sonner';
import { ApiError } from '@/shared/api/api-error';

/** Toast de sucesso. */
export function notifySuccess(message: string): void {
  toast.success(message);
}

/** Toast de erro; inclui o traceId para suporte quando a API informar. */
export function notifyError(
  error: unknown,
  fallback = 'Não foi possível concluir a operação',
): void {
  if (error instanceof ApiError) {
    const description =
      error.traceId === undefined ? undefined : `Código de rastreio: ${error.traceId}`;
    toast.error(error.detail ?? error.title, description === undefined ? {} : { description });
    return;
  }
  toast.error(fallback);
}
